import { render } from "./TestsView.vue?vue&type=template&id=7fd667b2&scoped=true"
import script from "./TestsView.vue?vue&type=script&lang=js"
export * from "./TestsView.vue?vue&type=script&lang=js"

import "./TestsView.vue?vue&type=style&index=0&id=7fd667b2&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd667b2"]])

export default __exports__